import { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
// import { IoIosArrowBack } from "react-icons/io";
import { Loader } from 'react-overlay-loader';
import { BiEditAlt } from "react-icons/bi";
import { toast } from 'react-toastify';

export default function Svgcategory() {

    const Token = localStorage.getItem("token")
    const location = useLocation()
    const url = location?.state?.url
    // Parse the URL and its query parameters
    const [formData, setFormData] = useState({
        family_last_name: "",
        slogan: "",
        colour_code: "",
        svg_category_id: "",
        svg_id: "",
        url: ""

    });

    useEffect(() => {
        if (url) {
            // Create a URL object to parse the URL
            const urlObject = new URL(url);
            const queryParams = new URLSearchParams(urlObject.search);
            // Extract the parameters
            const familyLastName = queryParams.get('family_last_name');
            const slogan = queryParams.get('slogan');
            const colourCode = queryParams.get('colour_code');
            const svgCategoryId = queryParams.get('svg_category_id');
            const svgId = queryParams.get('svgid');

            // Update the state with the extracted values
            setFormData({
                family_last_name: familyLastName || "",
                slogan: slogan || "",
                colour_code: colourCode || "",
                svg_category_id: svgCategoryId || "",
                svg_id: svgId,
                url: url

            });
        }
    }, [url]);

    const navigate = useNavigate()
    const [loader, setLoader] = useState(false);

    // const [formData] = useState({

    //     family_last_name: "Hnh Soft Tech Pvt Limited",
    //     slogan: "Your Potential our Passion",
    //     colour_code: ["#FB0505", "#4CD964", "#FF8A01"],
    //     svg_category_id: "2b271d72-02c5-4153-9f4e-956ec1cfdcd1",
    //     svg_id: "250e8a28-439e-46ec-97d5-9d8b4bb9923e",
    //     url: url

    // });

    const [response, setResponse] = useState([]);
    const [selectedIdx, setSelectedIdx] = useState(null);
    const [selectedSvgCode, setSelectedSvgCode] = useState(null);
    const [selectedSvgid, setSelectedSvgid] = useState(null);

    const handleBoxClick = (index, svgid, svgcode) => {
        console.log(svgcode)
        setSelectedSvgCode(svgcode)
        setSelectedSvgid(svgid)
        setSelectedIdx(index === selectedIdx ? null : index);
    };

    useEffect(() => {
        window.scroll(0, 0)
        if (formData.svg_category_id) {
            postData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData])

    const postData = async () => {
        setLoader(true)

        window.scroll(0, 0)
        try {
            const response = await fetch('https://fhbapi.devssh.xyz/api/v1/logo_details/get_svgs_category_webview/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${Token}`
                },
                body: JSON.stringify(formData)
            });
            const data = await response.json();
            setLoader(false)
            if (data?.data?.length === 0) {
                // toast.error("No category found")
                setResponse([]); // Clear the response
                // alert('No category found');
                ; // You can set this message in the response state or another state
            } else {
                setResponse(data?.data);
            }


        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const DataMove = () => {
        navigate('/editor', { state: { Data: selectedSvgCode, svgid: selectedSvgid, url: url } })

    }

    const DataBack = () => {
        navigate('/editor', { state: { Data: selectedSvgCode, svgid: selectedSvgid, url: url } })

    }

    return (
        <>
            {loader && <Loader fullPage loading />}
            <main className="main_wrapper overflow-hidden">
                <section className="shop__page__wrap">
                    <div className="container-fluid full__width__padding">
                        <div className="row">
                            <div className="col-xl-12 col-lg-12 col-md-12">
                                <div className="tab-content" id="myTabContent" data-aos="fade-up">
                                    <div className="tab-pane fade active show" id="list_view">
                                        <div className="row d-flex justify-content-center align-items-center flex-column">
                                            {response.length > 0 ? (
                                                response.map((item, index) => (
                                                    <div key={item.id} className='col-xl-3 col-lg-3 col-md-4 overflow-hidden col-sm-12  column__custom__class' onClick={() => handleBoxClick(index, item.id, item.svg_code.replace(/ns0:/g, ''))}>
                                                        <div className={`gridarea__wraper product__grid  ${index === selectedIdx ? 'clicked' : ''}`}>
                                                            <div className="gridarea__img position-relative">
                                                                <div className='iconsstyle' onClick={() => DataMove()}><BiEditAlt size={22} /></div>
                                                                <div dangerouslySetInnerHTML={{ __html: item.svg_code.replace(/ns0:/g, '') }} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                            ) : (
                                                <div className="no-category-message d-flex justify-content-center align-items-center">
                                                    <h3>No category found</h3>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="fixed-buttons d-flex justify-content-center align-items-center">
                                        {response && response.length > 0 ? (
                                            <button className="btn btn-primary fixed-width-btn-prmi" onClick={DataMove}>
                                                Next
                                            </button>
                                        ) : (
                                            <button className="btn btn-secondary fixed-width-btn-prmi" onClick={() => navigate(-1)}>
                                                Back
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </>
    );
}
